import { useState } from 'react'
import { Link } from 'react-router-dom'
import { EnrollmentModal } from '../../components/EnrollmentModal'

export function Nigeria() {
  const [enrollmentModalOpen, setEnrollmentModalOpen] = useState(false)

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-xl sm:text-2xl font-bold text-blue-600">EMR</Link>
            <div className="flex items-center space-x-4">
              <Link to="/login" className="text-gray-700 hover:text-blue-600 transition">Sign In</Link>
              <button
                onClick={() => setEnrollmentModalOpen(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="bg-gradient-to-br from-green-50 via-white to-green-50 py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-6xl mb-6">🇳🇬</div>
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            EMR for <span className="text-green-600">Nigeria</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Designed for Nigerian healthcare facilities with NHIS integration, offline-first capability,
            and multi-language support including Yoruba, Igbo, and Hausa.
          </p>
          <button
            onClick={() => setEnrollmentModalOpen(true)}
            className="bg-green-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-green-700 transition"
          >
            Start Free Trial
          </button>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">Nigerian Healthcare Features</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">💳</div>
              <h3 className="text-xl font-semibold mb-2">NHIS Integration</h3>
              <p className="text-gray-600">
                National Health Insurance Scheme billing and claims processing for HMOs and providers.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">☁️</div>
              <h3 className="text-xl font-semibold mb-2">Offline-First</h3>
              <p className="text-gray-600">
                Works completely offline with intelligent sync. Perfect for areas with unreliable connectivity.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">🌍</div>
              <h3 className="text-xl font-semibold mb-2">Multi-Language</h3>
              <p className="text-gray-600">
                Support for English, Yoruba, Igbo, Hausa, and Pidgin for patient communication.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">📱</div>
              <h3 className="text-xl font-semibold mb-2">Mobile-First</h3>
              <p className="text-gray-600">
                Optimized for mobile devices and low-bandwidth connections common in Nigeria.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">💉</div>
              <h3 className="text-xl font-semibold mb-2">Disease Surveillance</h3>
              <p className="text-gray-600">
                Integration with NCDC for disease reporting and public health surveillance.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">💰</div>
              <h3 className="text-xl font-semibold mb-2">Naira Billing</h3>
              <p className="text-gray-600">
                Full support for NGN currency, local payment gateways, and cash payment tracking.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Link to="/" className="text-white hover:text-blue-400 transition">← Back to Home</Link>
          <p className="mt-4 text-sm">&copy; {new Date().getFullYear()} EMR System. All rights reserved.</p>
        </div>
      </footer>

      <EnrollmentModal
        isOpen={enrollmentModalOpen}
        onClose={() => setEnrollmentModalOpen(false)}
      />
    </div>
  )
}

